// extracted by mini-css-extract-plugin
export default {"pageContainer":"StitchPattern_pageContainer__0qiWE","colRowNumberCell":"StitchPattern_colRowNumberCell__sOVBk"};